import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import {NavBtnLink} from "./NavbarElements"
const LogoutButton = () => {
    const { logout, isAuthenticated } = useAuth0();
    return (
        isAuthenticated && (
            <NavBtnLink to="/" onClick={logout}>Log Out</NavBtnLink>
        )
    )
}

export default LogoutButton
